<template>
  <select
    v-model="selected"
    class="block bg-white sm:text-sm"
    :disabled="disabled"
    :id="id"
    :class="[
      inset
        ? 'mt-1 border-0 px-0 pt-0 pb-0 text-gray-900 placeholder-gray-200 focus:ring-0 sm:text-sm'
        : 'rounded-md border border-gray-300 py-0 focus:border-green-500 focus:ring-green-500',
      disabled ? 'bg-gray-100' : '',
      shadow ? (inset ? '' : 'shadow') : '',
      expand ? (mdExpand ? 'w-full' : 'w-full md:w-auto') : '',
      customHeight ? customHeight : inset ? 'h-auto' : sizeClass,
    ]"
    :style="{ width: fit ? 'fit-content' : null, minWidth }"
    v-on:change="handleChange"
    v-on:focus="handleFocus"
  >
    <slot>
      <option
        v-for="option in options"
        :key="option.key"
        :value="option.value"
        :disabled="option.disabled"
      >
        {{ option.label }}
      </option>
    </slot>
  </select>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    value: null,
    id: null,
    minWidth: String,
    options: {
      type: Array,
      required: false,
    },
    inset: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    expand: {
      type: Boolean,
      default: false,
    },
    mdExpand: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customHeight: {
      type: [String, Boolean],
      default: null,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  emits: ['input', 'change'],
  computed: {
    selected: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    sizeClass() {
      const sizes = {
        sm: 'h-8',
        md: 'h-10',
      };

      return sizes[this.size];
    },
  },
  methods: {
    handleChange: function () {
      this.$emit('change');
    },
    handleFocus: function () {
      this.$emit('focus');
    },
  },
};
</script>
